import React, { useState } from 'react';
import { Button, Dialog, Box, Typography, Slider, Stack } from '@mui/material';
import Cropper from 'react-easy-crop';
import getCroppedImg from 'utils/cropImage';

const ImageCropper = ({ image, cropRatio = 1 / 1, isOpenModal, handleClose }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(URL.createObjectURL(image), croppedAreaPixels, rotation, image?.type);
      handleClose(croppedImage);
    } catch (e) {
      console.error(e);
    }
  };

  const handleUploadOriginal = () => {
    handleClose(image);
  };
  return (
    <Dialog
      open={Boolean(isOpenModal)}
      onClose={() => handleClose('')}
      maxWidth={'sm'}
      fullWidth
    >
      <Box sx={{ padding: '20px' }}>
        <Box sx={{ position: 'relative', width: '100%', height: 300 }}>
          <Cropper
            image={image ? URL.createObjectURL(image) : ''}
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={cropRatio}
            minZoom={0.5}
            restrictPosition={false}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </Box>
        <Box sx={{ padding: 2, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
          <Box>
            <Typography
              variant="subtitle1"
              color="secondary"
            >
              Zoom
            </Typography>
            <Slider
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              aria-labelledby="Zoom"
              onChange={(e, zoom) => setZoom(zoom)}
            />
          </Box>
          <Box>
            <Typography
              variant="subtitle1"
              color="secondary"
            >
              Rotation
            </Typography>
            <Slider
              value={rotation}
              min={0}
              max={360}
              step={1}
              aria-labelledby="Rotation"
              onChange={(e, rotation) => setRotation(rotation)}
            />
          </Box>
        </Box>
        <Stack
          direction="row"
          spacing={1}
          justifyContent="space-between"
        >
          <Box></Box>
          <Stack
            direction="row"
            spacing={1}
            sx={{ flexBasis: '40%' }}
            alignItems="center"
          >
            <Button
              onClick={handleUploadOriginal}
              fullWidth
              variant="outlined"
              color="primary"
            >
              Upload Original
            </Button>
            <Button
              onClick={showCroppedImage}
              fullWidth
              variant="contained"
              color="primary"
            >
              Upload
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default ImageCropper;
